import { supabase } from "@/integrations/supabase/client";
import type { LegalAcceptanceRecord, LegalVersions } from "@/lib/legalVersions";

type LegalAcceptanceContext = "activation" | "subscription" | "notice";

/** Table ou fonction introuvable : le front est en ligne avant la migration. */
export function isLegalAcceptanceUnavailable(error: { code?: string } | null | undefined): boolean {
  return error?.code === "PGRST202" || error?.code === "PGRST205" || error?.code === "42P01";
}

/** Acceptations du compte connecté ; la RLS ne lui montre que les siennes. */
export function fetchMyLegalAcceptances(userId: string) {
  return (
    supabase
      .from("legal_acceptances")
      .select("document, version, action")
      .eq("user_id", userId)
      // Le type généré dit `string` ; les contraintes de la table n'admettent que ces documents et actions.
      .overrideTypes<LegalAcceptanceRecord[], { merge: false }>()
  );
}

/**
 * Enregistre l'acceptation des textes montrés à l'écran, dans leur version, ou
 * seulement l'information (« informed ») depuis le bandeau. Compte, e-mail et
 * heure sont fixés par le serveur ; le magasin ne sert qu'à la souscription, et
 * la RPC vérifie que le compte en est le propriétaire.
 */
export function recordLegalAcceptance({
  versions,
  context,
  action = "accepted",
  storeId = null,
}: {
  versions: LegalVersions;
  context: LegalAcceptanceContext;
  action?: LegalAcceptanceRecord["action"];
  storeId?: string | null;
}) {
  return supabase.rpc("record_legal_acceptance", {
    p_versions: versions,
    p_context: context,
    p_action: action,
    // Sans magasin, la RPC garde sa valeur par défaut (NULL).
    p_store_id: storeId ?? undefined,
  });
}
